// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__PgFqY","rightAdornment":"Header_rightAdornment__2v3VE"};